import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';
import { TagPicker } from 'rsuite';

import InputWrapper from './InputWrapper';

export const HookFormTagPicker = ({
  name,
  defaultValue = [],
  required = false,
  label = '',
  isTextArea = false,
  isHidden = false,
  largeLabel = false,
  rules = {},
  badgeComponent = null,
  hasCopyButton = false,
  disabled = false,
  upgradePrompt = '',
  data = {},
  boldLabel = false,
  ...rest
}) => {
  // prevents issues where defaultValue is null
  const defaultInputValue = defaultValue || [];
  const { setValue, register, formState, watch, unregister } = useFormContext();
  const value = watch(name, defaultInputValue);
  const error = formState?.errors?.[name];

  const onChange = (value) => {
    setValue(name, value);
  };

  useEffect(() => {
    register(name);

    return () => unregister(name);
  }, [register]);

  useEffect(() => {
    setValue(name, defaultInputValue);
  }, [defaultInputValue]);

  return (
    <InputWrapper
    isHidden={isHidden}
    label={label}
    errorMessage={error?.message}
    largeLabel={largeLabel}
    boldLabel={boldLabel}
    >
      <TagPicker
        onChange={onChange}
        value={value}
        disabled={disabled}
        data={data}
        valueKey="label"
        {...rest}
      />
    </InputWrapper>
  );
};

HookFormTagPicker.propTypes = {
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.arrayOf(PropTypes.string),
  required: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  label: PropTypes.string,
  badgeComponent: PropTypes.element,
  isTextArea: PropTypes.bool,
  largeLabel: PropTypes.bool,
  boldLabel: PropTypes.bool,
  rules: PropTypes.object,
  hasCopyButton: PropTypes.bool,
};

export default HookFormTagPicker;



// WEBPACK FOOTER //
// ./src/components/HookFormInputs/HookFormTagPicker.jsx